var _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _path5, _rect4, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductCcm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "One document delivered through email, mobile and print") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147 100h55m0-62v128m0-128h44m-44 62h62m-62 66h44",
    stroke: "#E5D4C7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 43,
    width: 96,
    height: 116,
    rx: 10,
    fill: "#FFF1E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h54M71 87h54M71 104h37M71 132h24",
    stroke: "#B69782",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 16,
    width: 80,
    height: 46,
    rx: 7,
    fill: "#E8EDF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m253 25 33 23 33-23",
    stroke: "#596475",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 73,
    width: 40,
    height: 55,
    rx: 7,
    fill: "#E8EDF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M278 81h14M283 120h4",
    stroke: "#596475",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M275 94h20M275 102h14",
    stroke: "#A6B2C2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 143,
    width: 67,
    height: 46,
    rx: 6,
    fill: "#FFF1E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266 155h41M266 165h41M266 175h26",
    stroke: "#B69782",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCcm);
export default __webpack_public_path__ + "static/media/product-ccm.a31fcebc1b695d0bdd8234748be000f5.svg";
export { ForwardRef as ReactComponent };